var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    y: 0.5,
    fill: "#fff",
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E0F0C",
    d: "M33.43 23.643h-9.515c-.428-2.443-2.528-4.286-5.057-4.286-2.827 0-5.143 2.315-5.143 5.143 0 2.83 2.315 5.143 5.143 5.143 2.529 0 4.672-1.843 5.057-4.286h5.229v3.43h1.714v-3.43h1.715v3.43h1.714V24.5a.86.86 0 0 0-.857-.857M18.858 27.93a3.44 3.44 0 0 1-3.427-3.43 3.44 3.44 0 0 1 3.428-3.428 3.44 3.44 0 0 1 3.428 3.428 3.44 3.44 0 0 1-3.43 3.43"
  })));
};
export default SvgKey;